module.exports = __webpack_public_path__ + "static/media/puniclogo.d684757f.png";